import {computed} from "mobx";
import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {FormationPositionDomainModel} from "./formation-position.domain-model";

export class FormationPositionViewModel extends BaseViewModel {
  domainModel: FormationPositionDomainModel;

  @computed get shortName(): String {
    return this.domainModel.shortName;
  }

  @computed get order(): Number {
    return this.domainModel.order;
  }
}
